import PlanPaymentContainer from "./PlanPaymentContainer";
import PlanPaymentStore from "./PlanPaymentStore";

export default PlanPaymentStore(PlanPaymentContainer);
